
define('template!calendarEditView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 var dis = canEdit ? '' : 'disabled'; ;
__p += '\n<div class="body calendar-edit-body">\n\n  ';
 if (status === 'REJECTED' && rejectionReason) { ;
__p += '\n    <div class="alert alert-danger">\n      ' +
((__t = ( _.i18n('calendar.rejectedNote', null, 'This request was rejected:') )) == null ? '' : __t) +
'\n      <strong>' +
((__t = ( rejectionReason )) == null ? '' : __t) +
'</strong>\n    </div>\n  ';
 } else if (status === 'PENDING_APPROVAL' && !isNew) { ;
__p += '\n    <div class="alert alert-warning">\n      ' +
((__t = ( _.i18n('calendar.pendingNote', null, 'This vacation request is awaiting manager approval.') )) == null ? '' : __t) +
'\n    </div>\n  ';
 } ;
__p += '\n\n  <div class="item">\n    <div class="title">' +
((__t = ( _.i18n('calendar.title', null, 'Title') )) == null ? '' : __t) +
'</div>\n    <div class="value">\n      <input type="text" class="form-control js-title" value="' +
((__t = ( title )) == null ? '' : __t) +
'" ' +
((__t = ( dis )) == null ? '' : __t) +
'>\n    </div>\n  </div>\n\n  <div class="item">\n    <div class="title">' +
((__t = ( _.i18n('calendar.description', null, 'Description') )) == null ? '' : __t) +
'</div>\n    <div class="value">\n      <textarea class="form-control js-description" rows="2" ' +
((__t = ( dis )) == null ? '' : __t) +
'>' +
((__t = ( description )) == null ? '' : __t) +
'</textarea>\n    </div>\n  </div>\n\n  <div class="item">\n    <div class="title">' +
((__t = ( _.i18n('calendar.type', null, 'Type') )) == null ? '' : __t) +
'</div>\n    <div class="value">\n      <select class="form-control js-type" ' +
((__t = ( dis )) == null ? '' : __t) +
'>\n        <option value="PERSONAL" ' +
((__t = ( type === 'PERSONAL' ? 'selected' : '' )) == null ? '' : __t) +
'>' +
((__t = ( _.i18n('calendar.type.personal', null, 'Personal') )) == null ? '' : __t) +
'</option>\n        ';
 if (isManager || type === 'COMMON') { ;
__p += '\n          <option value="COMMON" ' +
((__t = ( type === 'COMMON' ? 'selected' : '' )) == null ? '' : __t) +
'>' +
((__t = ( _.i18n('calendar.type.common', null, 'Common (account-wide)') )) == null ? '' : __t) +
'</option>\n        ';
 } ;
__p += '\n        <option value="VACATION" ' +
((__t = ( type === 'VACATION' ? 'selected' : '' )) == null ? '' : __t) +
'>' +
((__t = ( _.i18n('calendar.type.vacation', null, 'Vacation (needs approval)') )) == null ? '' : __t) +
'</option>\n      </select>\n    </div>\n  </div>\n\n  <div class="item">\n    <div class="title">' +
((__t = ( _.i18n('calendar.category', null, 'Category') )) == null ? '' : __t) +
'</div>\n    <div class="value">\n      <select class="form-control js-category" ' +
((__t = ( dis )) == null ? '' : __t) +
'>\n        <option value="MEETING" ' +
((__t = ( category === 'MEETING' ? 'selected' : '' )) == null ? '' : __t) +
'>' +
((__t = ( _.i18n('calendar.category.meeting', null, 'Meeting') )) == null ? '' : __t) +
'</option>\n        <option value="VACATION" ' +
((__t = ( category === 'VACATION' ? 'selected' : '' )) == null ? '' : __t) +
'>' +
((__t = ( _.i18n('calendar.category.vacation', null, 'Vacation') )) == null ? '' : __t) +
'</option>\n        <option value="DEADLINE" ' +
((__t = ( category === 'DEADLINE' ? 'selected' : '' )) == null ? '' : __t) +
'>' +
((__t = ( _.i18n('calendar.category.deadline', null, 'Deadline') )) == null ? '' : __t) +
'</option>\n        <option value="OTHER" ' +
((__t = ( category === 'OTHER' ? 'selected' : '' )) == null ? '' : __t) +
'>' +
((__t = ( _.i18n('calendar.category.other', null, 'Other') )) == null ? '' : __t) +
'</option>\n      </select>\n    </div>\n  </div>\n\n  <div class="item">\n    <div class="title">' +
((__t = ( _.i18n('calendar.color', null, 'Colour (optional)') )) == null ? '' : __t) +
'</div>\n    <div class="value">\n      <input type="color" class="js-color" value="' +
((__t = ( colorValue )) == null ? '' : __t) +
'" ' +
((__t = ( dis )) == null ? '' : __t) +
'>\n    </div>\n  </div>\n\n  <div class="item">\n    <div class="title">' +
((__t = ( _.i18n('calendar.allDay', null, 'All day') )) == null ? '' : __t) +
'</div>\n    <div class="value">\n      <input type="checkbox" class="js-all-day" ' +
((__t = ( allDay ? 'checked' : '' )) == null ? '' : __t) +
' ' +
((__t = ( dis )) == null ? '' : __t) +
'>\n    </div>\n  </div>\n\n  <div class="item js-half-day-row hidden">\n    <div class="title">' +
((__t = ( _.i18n('calendar.halfDay', null, 'Half day') )) == null ? '' : __t) +
'</div>\n    <div class="value">\n      <select class="form-control js-half-day-part" ' +
((__t = ( dis )) == null ? '' : __t) +
'>\n        <option value="FULL" ' +
((__t = ( halfDayPart === 'FULL' ? 'selected' : '' )) == null ? '' : __t) +
'>' +
((__t = ( _.i18n('calendar.halfDay.full', null, 'Full day') )) == null ? '' : __t) +
'</option>\n        <option value="AM" ' +
((__t = ( halfDayPart === 'AM' ? 'selected' : '' )) == null ? '' : __t) +
'>' +
((__t = ( _.i18n('calendar.halfDay.am', null, 'Morning') )) == null ? '' : __t) +
'</option>\n        <option value="PM" ' +
((__t = ( halfDayPart === 'PM' ? 'selected' : '' )) == null ? '' : __t) +
'>' +
((__t = ( _.i18n('calendar.halfDay.pm', null, 'Afternoon') )) == null ? '' : __t) +
'</option>\n      </select>\n    </div>\n  </div>\n\n  <div class="item">\n    <div class="title">' +
((__t = ( _.i18n('calendar.start', null, 'Start') )) == null ? '' : __t) +
'</div>\n    <div class="value">\n      <input type="' +
((__t = ( allDay ? 'date' : 'datetime-local' )) == null ? '' : __t) +
'" class="form-control js-start" value="' +
((__t = ( allDay ? startDate : start )) == null ? '' : __t) +
'" ' +
((__t = ( dis )) == null ? '' : __t) +
'>\n    </div>\n  </div>\n\n  <div class="item">\n    <div class="title">' +
((__t = ( _.i18n('calendar.end', null, 'End') )) == null ? '' : __t) +
'</div>\n    <div class="value">\n      <input type="' +
((__t = ( allDay ? 'date' : 'datetime-local' )) == null ? '' : __t) +
'" class="form-control js-end" value="' +
((__t = ( allDay ? endDate : end )) == null ? '' : __t) +
'" ' +
((__t = ( dis )) == null ? '' : __t) +
'>\n    </div>\n  </div>\n\n  <div class="item">\n    <div class="title">' +
((__t = ( _.i18n('calendar.reminder', null, 'Reminder') )) == null ? '' : __t) +
'</div>\n    <div class="value">\n      <select class="form-control js-reminder" ' +
((__t = ( dis )) == null ? '' : __t) +
'>\n        <option value="" ' +
((__t = ( reminderMinutesBefore === '' ? 'selected' : '' )) == null ? '' : __t) +
'>' +
((__t = ( _.i18n('calendar.reminder.none', null, 'No reminder') )) == null ? '' : __t) +
'</option>\n        <option value="0" ' +
((__t = ( reminderMinutesBefore === '0' ? 'selected' : '' )) == null ? '' : __t) +
'>' +
((__t = ( _.i18n('calendar.reminder.atStart', null, 'At start time') )) == null ? '' : __t) +
'</option>\n        <option value="10" ' +
((__t = ( reminderMinutesBefore === '10' ? 'selected' : '' )) == null ? '' : __t) +
'>' +
((__t = ( _.i18n('calendar.reminder.10min', null, '10 minutes before') )) == null ? '' : __t) +
'</option>\n        <option value="30" ' +
((__t = ( reminderMinutesBefore === '30' ? 'selected' : '' )) == null ? '' : __t) +
'>' +
((__t = ( _.i18n('calendar.reminder.30min', null, '30 minutes before') )) == null ? '' : __t) +
'</option>\n        <option value="60" ' +
((__t = ( reminderMinutesBefore === '60' ? 'selected' : '' )) == null ? '' : __t) +
'>' +
((__t = ( _.i18n('calendar.reminder.1hour', null, '1 hour before') )) == null ? '' : __t) +
'</option>\n        <option value="1440" ' +
((__t = ( reminderMinutesBefore === '1440' ? 'selected' : '' )) == null ? '' : __t) +
'>' +
((__t = ( _.i18n('calendar.reminder.1day', null, '1 day before') )) == null ? '' : __t) +
'</option>\n      </select>\n    </div>\n  </div>\n\n  <div class="item">\n    <div class="title">' +
((__t = ( _.i18n('calendar.recurrence', null, 'Repeat') )) == null ? '' : __t) +
'</div>\n    <div class="value">\n      <select class="form-control js-recurrence-freq" ' +
((__t = ( dis )) == null ? '' : __t) +
'>\n        <option value="NONE" ' +
((__t = ( recurrenceFreq === 'NONE' ? 'selected' : '' )) == null ? '' : __t) +
'>' +
((__t = ( _.i18n('calendar.recurrence.none', null, 'Does not repeat') )) == null ? '' : __t) +
'</option>\n        <option value="DAILY" ' +
((__t = ( recurrenceFreq === 'DAILY' ? 'selected' : '' )) == null ? '' : __t) +
'>' +
((__t = ( _.i18n('calendar.recurrence.daily', null, 'Daily') )) == null ? '' : __t) +
'</option>\n        <option value="WEEKLY" ' +
((__t = ( recurrenceFreq === 'WEEKLY' ? 'selected' : '' )) == null ? '' : __t) +
'>' +
((__t = ( _.i18n('calendar.recurrence.weekly', null, 'Weekly') )) == null ? '' : __t) +
'</option>\n        <option value="MONTHLY" ' +
((__t = ( recurrenceFreq === 'MONTHLY' ? 'selected' : '' )) == null ? '' : __t) +
'>' +
((__t = ( _.i18n('calendar.recurrence.monthly', null, 'Monthly') )) == null ? '' : __t) +
'</option>\n        <option value="YEARLY" ' +
((__t = ( recurrenceFreq === 'YEARLY' ? 'selected' : '' )) == null ? '' : __t) +
'>' +
((__t = ( _.i18n('calendar.recurrence.yearly', null, 'Yearly') )) == null ? '' : __t) +
'</option>\n      </select>\n    </div>\n  </div>\n\n  <div class="js-recurrence-options hidden">\n    <div class="item">\n      <div class="title">' +
((__t = ( _.i18n('calendar.recurrence.interval', null, 'Every') )) == null ? '' : __t) +
'</div>\n      <div class="value">\n        <input type="number" min="1" class="form-control js-recurrence-interval" value="' +
((__t = ( recurrenceInterval )) == null ? '' : __t) +
'" ' +
((__t = ( dis )) == null ? '' : __t) +
'>\n      </div>\n    </div>\n\n    <div class="item js-byday-row hidden">\n      <div class="title">' +
((__t = ( _.i18n('calendar.recurrence.byday', null, 'On days') )) == null ? '' : __t) +
'</div>\n      <div class="value byday-checkboxes">\n        ';
 _.each(weekdays, function (d) { ;
__p += '\n          <label class="byday-label">\n            <input type="checkbox" class="js-byday" value="' +
((__t = ( d )) == null ? '' : __t) +
'" ' +
((__t = ( (recurrenceByDay && recurrenceByDay.indexOf(d) >= 0) ? 'checked' : '' )) == null ? '' : __t) +
' ' +
((__t = ( dis )) == null ? '' : __t) +
'>\n            ' +
((__t = ( _.i18n('calendar.day.' + d, null, d) )) == null ? '' : __t) +
'\n          </label>\n        ';
 }); ;
__p += '\n      </div>\n    </div>\n\n    <div class="item">\n      <div class="title">' +
((__t = ( _.i18n('calendar.recurrence.until', null, 'Until') )) == null ? '' : __t) +
'</div>\n      <div class="value">\n        <input type="date" class="form-control js-recurrence-until" value="' +
((__t = ( recurrenceUntil )) == null ? '' : __t) +
'" ' +
((__t = ( dis )) == null ? '' : __t) +
'>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class="footer">\n  <div class="left">\n    <div class="load">\n      <div class="loader-2"></div>\n      <div class="text"></div>\n    </div>\n    ';
 if (!isNew && canEdit) { ;
__p += '\n      <button type="button" class="btn btn-danger js-delete">' +
((__t = ( _.i18n('calendar.delete', null, 'Delete') )) == null ? '' : __t) +
'</button>\n    ';
 } ;
__p += '\n  </div>\n  <div class="right">\n    ';
 if (showApproval) { ;
__p += '\n      <button type="button" class="btn btn-success js-approve">' +
((__t = ( _.i18n('calendar.approve', null, 'Approve') )) == null ? '' : __t) +
'</button>\n      <button type="button" class="btn btn-warning js-reject">' +
((__t = ( _.i18n('calendar.reject', null, 'Reject') )) == null ? '' : __t) +
'</button>\n    ';
 } ;
__p += '\n    <div class="cancel-region"></div>\n    <div class="confirm-region"></div>\n  </div>\n</div>\n';

}
return __p
};});

